
class collectionPage {
    constructor(){
      if (performance.navigation.type == 2) {
            // window.location.reload();
      }
      this.collectionPage = document.querySelector("[collection-page]");
      this.updateProductCount();
      this.bindSwatchEvents();
      
      if (this.collectionPage.querySelectorAll("[clear-filter]").length > 0 ) {
        this.collectionPage.querySelector("[clear-filter]").addEventListener("click",(event)=>{
          this._clearFilter(event);
        })
      };
    };

    updateProductCount() {
      let productCount = this.collectionPage.querySelectorAll("[data-product-grid]").length;
      let filteredProductCount = this.collectionPage.querySelector("[product-count]");
      if (filteredProductCount) {
        filteredProductCount = filteredProductCount.innerHTML;
        filteredProductCount = filteredProductCount.replace("Results found","");
        let totalProductsEle = document.querySelector('[data-totalProducts]');
        if (totalProductsEle) {
          totalProductsEle.innerHTML =`Showing  ${productCount} of ${filteredProductCount}`;
        }
      }
    }

    bindSwatchEvents() {
      if (document.querySelectorAll("[data-color-swatch-options]").length > 0 ) {
        document.querySelectorAll("[data-color-swatch-options]").forEach(ele=>{
          ele.addEventListener("click",(event)=>{
            event.preventDefault();
            this._changeSwatch(event);
          })
        })
      }
    }

    observeGridChanges() {
      // Watch for changes to the product grid (AJAX updates)
      const productGrid = document.getElementById('collection-product-grid');
      if (!productGrid) return;

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            // Products were added/replaced via AJAX
            // Re-bind swatch click events
            this.bindSwatchEvents();
            
            // Update product count
            this.updateProductCount();
          }
        });
      });

      observer.observe(productGrid, {
        childList: true,
        subtree: true
      });
    }

   
    _clearFilter(event){
      event.preventDefault();
      window.location = window.location.pathname;
    }
    
    _changeSwatch(event){
        let currentEle = event.currentTarget;
        let colorName =  currentEle.querySelector('[name="Color"]').value;
        let parentEle =  currentEle.closest("[data-product-grid]");
        let variant_json = parentEle.querySelector('[data-variantJSON]');
        let variantData =  JSON.parse(variant_json.textContent);
        
        variantData.forEach(ele=>{
          // Check exact match first, then check if color is part of multi-option title
          if (ele.title == colorName || 
              (ele.title.includes(' / ') && ele.title.split(' / ').some(opt => opt.trim() === colorName)) ||
              (ele.options && ele.options.includes(colorName))) {
            setTimeout(() => {
              parentEle.querySelector("[data-set-variant-id]").value = ele.id;
              let price = Shopify.formatMoney(ele.price, window.globalVariables.money_format);
              parentEle.querySelector("[data-currentprice]").innerHTML = price;
              
              // Always update and show the image
              let imgElement = parentEle.querySelector("[data-feauredimage]");
              if (imgElement && ele.featured_image && ele.featured_image.src) {
                imgElement.srcset = ele.featured_image.src;
                imgElement.src = ele.featured_image.src;
                imgElement.style.opacity = '1';
              } else if (imgElement) {
                imgElement.style.opacity = '1';
              }
              
              // Only hide video for non-first variants
              let videoElement = parentEle.querySelector('.card-img video');
              let isFirstVariant = variantData[0] && variantData[0].id === ele.id;
              if (videoElement && !isFirstVariant) {
                videoElement.style.display = 'none';
              }
              
              // Update button state based on availability
              let addButton = parentEle.querySelector('button[name="add"]');
              let addButtonText = addButton ? addButton.querySelector('.add-text') : null;
              let isPreorder = parentEle.dataset.preorder === 'true';
              // Check if variant should show Pre-order (zero stock but continue selling)
              let isVariantPreorder = ele.available && ele.inventory_quantity <= 0 && ele.inventory_policy === 'continue';
              if (addButton && addButtonText) {
                if (ele.available) {
                  addButton.disabled = false;
                  addButton.classList.remove('btn-secondary');
                  addButton.classList.add('btn-primary');
                  // Check for bundle collection text, variant preorder, or product-level preorder
                  let bundleText = addButton.dataset.bundleText;
                  if (bundleText) {
                    addButtonText.textContent = bundleText;
                  } else if (isVariantPreorder || isPreorder) {
                    addButtonText.textContent = 'Pre-Order';
                  } else {
                    addButtonText.textContent = 'Add to Bag';
                  }
                } else {
                  addButton.disabled = true;
                  addButton.classList.remove('btn-primary');
                  addButton.classList.add('btn-secondary');
                  addButtonText.textContent = 'Sold out';
                }
              }
            }, 50); 
          }
        })
        parentEle.querySelectorAll("[data-color-swatch-options]").forEach(ele=>{
          let colorEle = ele.querySelector('[name="Color"]');
          colorEle.removeAttribute("checked");
          colorEle.checked = false;
          ele.classList.remove('swatch-active'); // Remove swatch-active class
        });
        let radioButton =  currentEle.querySelector('[name="Color"]');
        radioButton.setAttribute("checked","")
        radioButton.checked = true;
        currentEle.classList.add('swatch-active'); // Add swatch-active class
    };

   
}
new collectionPage()

// var csActivated = Utility.getCookie('cs-activate');
// if (csActivated == 'false' || csActivated === undefined) {
//     Utility.setCookie('cs-url', `${window.location.origin}${window.location.pathname}`, 14);
//     Utility.setCookie('cs-page', '', 14);
//     Utility.setCookie('cs-product-id', '', 14);   
// }
// window.setupContinueShoppingButton = function() {
//     var allProductGrids = document.querySelectorAll('.collection-listing-product-grid');
//     allProductGrids.forEach(item => {
//         item.addEventListener('click', (e) => {
//             var productId = item.getAttribute('data-pr-id');
//             // var pageid = item.getAttribute('data-page-id');
//             var url_string = window.location.href; 
//             var url = new URL(url_string);
//             var pageid = url.searchParams.get("page");
//             var url = window.location.href;
//             Utility.setCookie('cs-url', `${url}`, 14);
//             Utility.setCookie('cs-page', pageid, 14);
//             Utility.setCookie('cs-product-id', productId, 14);
//             console.log(productId,'productIdproductId')
//         })
//     })
// } 
// window.setupContinueShoppingButton();
// var csActivated = Utility.getCookie('cs-activate');
// if (csActivated != null && csActivated != undefined) {
//   if (csActivated != 'false') {
//     var csProductId = Utility.getCookie('cs-product-id'); 
//     console.log(csProductId,'csProductIdcsProductId')
//     if (csProductId != null || csProductId != "" || csProductId != undefined) {
//       var productEl = document.querySelector(`.collection-listing-product-grid[data-pr-id="${csProductId}"]`);
//       if (productEl != null) {
//         var scrollingHeight = 80;
//         if (window.innerWidth < 991) {
//           var headerHeight = document.querySelector('sticky-header').offsetHeight;
//           scrollingHeight = headerHeight + 80;
//         }
//         setTimeout(() => {
//           window.scrollToSmoothly((productEl.offsetTop - scrollingHeight), 100);
//         }, 2000);
//       }
//     }
//     Utility.setCookie('cs-activate', false, 14);
//   }
// }

// window.scrollToSmoothly = function(pos, time) {
//   var currentPos = window.pageYOffset;
//   var start = null;
//   if(time == null) time = 500;
//   pos = +pos, time = +time;
//   window.requestAnimationFrame(function step(currentTime) {
//       start = !start ? currentTime : start;
//       var progress = currentTime - start;
//       if (currentPos < pos) {
//           window.scrollTo(0, ((pos - currentPos) * progress / time) + currentPos);
//       } else {
//           window.scrollTo(0, currentPos - ((currentPos - pos) * progress / time));
//       }
//       if (progress < time) {
//           window.requestAnimationFrame(step);
//       } else {
//           window.scrollTo(0, pos);
//       }
//   });
// }